import RejectController from 'eflex/pods/codes/reject/controller';

export default class CodesFaultController extends RejectController {
  get codes() {
    return this.codeRepo.faultCodes;
  }
}
